import { render, staticRenderFns } from "./secondary.vue?vue&type=template&id=7090c1fa&scoped=true&"
import script from "./secondary.vue?vue&type=script&lang=js&"
export * from "./secondary.vue?vue&type=script&lang=js&"
import style0 from "./secondary.vue?vue&type=style&index=0&id=7090c1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7090c1fa",
  null
  
)

export default component.exports